import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Modal, Row, Select, Space, Form, Radio } from "antd"
import { useForm } from "antd/lib/form/Form"
import TextArea from "antd/lib/input/TextArea"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

interface Prop {
    storeID?: string
}

let formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 10 }
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()
    const [form] = useForm()
    const [pregStatus, setPregStatus] = useState<number>(0)

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }

        })
    }

    useEffect(() => {
        getClientInfo()
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/add_minion_follow_records', {
            check_in_id: param.id,
            follow_time: form.getFieldValue('follow_time').format('YYYY-MM-DD'), // 跟进时间
            contact_success: form.getFieldValue('contact_success'), // 是否联系成功，0默认否 1是，整数类型
            preg_status: form.getFieldValue('preg_status'), // 怀孕时期，1正在备孕 5孕早期 6孕中期 7孕晚期 8预产期前7天 9已分娩 10超出预产期，整数类型
            expect_born_day: form.getFieldValue('expect_born_day').format('YYYY-MM-DD'), // 预产期
            follow_content: form.getFieldValue('follow_content'), // 跟进内容
            next_follow_limit_date: form.getFieldValue('next_follow_limit_date').format('YYYY-MM-DD'), // 下次跟进截止日期
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 录入管家跟进记录 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>录入管家跟进记录</Button>

        <Modal title="录入管家跟进记录" width={650} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={9}>
                    <Space>
                        <p>客人姓名：</p>
                        <p>{clientData?.check_in_user_name}</p>
                    </Space>
                    <Space>
                        <p>手机号码：</p>
                        <p>{clientData?.check_in_phone}</p>
                    </Space>
                </Col>

                <Col span={9}>
                    <Space>
                        <p>怀孕时期：</p>
                        <p>{clientData?.preg_status_desc}</p>
                    </Space>
                    <Space>
                        <p>预产期/分娩日：</p>
                        <p>{clientData?.expect_born_day}</p>
                    </Space>
                </Col>
            </Row>

            <Form {...formItemLayout} style={{ marginTop: 20 }} form={form}>
                <Form.Item label="跟进时间" name="follow_time">
                    <DatePicker placeholder="跟进时间" />
                </Form.Item>

                <Form.Item label="是否联系成功" name="contact_success">
                    <Radio.Group>
                        <Radio value={1}>有效</Radio>
                        <Radio value={0}>无效</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item label="怀孕时期" name="preg_status">
                    <Select onChange={(v: number) => setPregStatus(v)}>
                        {/* 1正在备孕 5孕早期 6孕中期 7孕晚期 8预产期前7天 9已分娩 10超出预产期 */}
                        <Option value={1} key={1}>正在备孕</Option>
                        <Option value={5} key={5}>孕早期</Option>
                        <Option value={6} key={6}>孕中期</Option>
                        <Option value={7} key={7}>孕晚期</Option>
                        <Option value={8} key={8}>预产期前7天</Option>
                        <Option value={9} key={9}>已分娩</Option>
                        <Option value={10} key={10}>超出预产期</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="expect_born_day" label="预产期">
                    <DatePicker placeholder="预产期" />
                </Form.Item>
                <Form.Item name="follow_content" label="跟进内容">
                    <TextArea style={{ height: 80 }} />
                </Form.Item>
                <Form.Item name="next_follow_limit_date" label="下次跟进截至日期">
                    <DatePicker placeholder="下次跟进截止日期" />
                </Form.Item>
            </Form>

            <div>
                <h4 style={{ color: 'red' }}>话术参考</h4>
                {pregStatus === 1 && <p>
                    1、备孕客户

                    1.1回访要求：签单后按照首访要求进行回访（备孕客户无需核对预产期、分娩医院）；

                    1.2回访话术：**女士，您好，我是您在禧月荟的管家***，接下来与您核对签单信息，您在X年X月X日在XX地点，签了XX门店的一份XXX的月子套餐对吗？在您备孕期间，我会一个月对您进行回访一次，如在备孕过程中您成功怀孕了，请您一定第一时间把这个好消息告诉我哦！请问这个联系电话可以添加到您的微信吗？稍后我将添加微信请您通过一下，随时保持联系，祝您早日备孕成功哦！
                </p>}

                {pregStatus === 5 && <p>
                    2、孕早期

                    2.1孕早期饮食建议：受激素水平影响，孕早期您可能会出现妊娠反应：如腹胀、恶心、呕吐、甚至便秘等，所以此阶段建议您饮食原则为：选择能促进食欲的食物；选择容易消化的食物；想吃就吃，少食多餐；确保糖的补充，避免酮症酸中毒。

                    2.2孕早期的营养饮食原则 ：

                    1.饮食清淡、适合的口味，选择容易消化的食物

                    2.少食多餐

                    3.保证摄入足够的碳水化合物

                    4.多摄入富含叶酸的食物

                    5.戒烟禁酒

                    参考《孕期知识库》内容，按照不同周期，针对性回访客户。
                </p>}

                {pregStatus === 6 && <p>
                    3、孕中期

                    3.1孕中期营养饮食原则 ：

                    适当增加鱼、禽、蛋、瘦肉、海的摄入量

                    适当增加奶类的摄入量

                    常吃含铁丰富的食物

                    适当身体运动，保持体重的合理增长

                    3.2回访话题参考：

                    3.2.1您现在体重大概增加了多少？并根据客户情况给一些饮食建议。

                    3.2.2邀约孕期课程/活动：您有没有兴趣来听我们的孕期课程？若客户感兴趣为她进行预约。（根据各分店的孕期课程时间推荐）

                    3.2.3您目前是坚持工作还是专门在家待产呢？

                    3.2.4可根据之前了解到的宝宝第几胎设置不同话题，例如：一胎妈妈更多的需要给到专业知识与经验分享；二胎客户可延展性问询大宝年纪，谁照顾等信息，更深入了解客户需求。

                    3.2.5发送物品清单给客户参考

                    为客户简单讲解准备物品内容（告知客户哪些是月子中心为其准备的，建议客户额外需准备哪些物品），使客户更清晰，准备更充分。

                </p>}

                {pregStatus === 7 && <p>
                    4、孕晚期

                    4.1饮食建议：整个怀孕期间OMEGA3和DHA有助于宝宝的眼睛、大脑、血液和神经系统的发育，尤其是在怀孕的最后三个月，胎宝宝的大脑发展非常迅速，应重视钙的摄取，孕妈需根据医生建议适当补钙。

                    4.2参考话术：

                    4.2.1这个阶段的您由于子宫快速增大压迫胃部，您的食量会减少，可以采取少食多餐制，每日增加至五餐以上，不要有剧烈的运动。

                    最后三个月，大约20%的孕妈妈会发生鼻子不通气或出血情况，这种情况大多是因为内分泌系统分泌的多种激素刺激鼻粘膜引起，分娩后这种现象会随之消失。尽量保持左侧位躺，这样宝宝供氧更充足。

                    4.2.2温馨提示孕期照：孕妈照最佳拍摄时间是28周-34周之间，在此期间您的身体形态呈现的是最好的状态，肚子浑圆饱满，身体行动也比较便捷，超过34周就不太适合拍摄了（如果套餐内赠送了孕妈摄影，则提醒客户提前预约拍摄，如套餐内不包含此服务，）

                    4.2.3问询水肿情况：请问您最近有出现水肿的现象吗？每个宝妈情况不同，水肿程度也不一样。出现水肿原因是子宫一定程度的扩大，可能压迫到静脉回流，这种现象会日益增强。预防水肿现象，平时可穿着弹性袜，睡觉时用枕头将双脚抬高，并以左侧位躺，还可以吃一些吃低盐、利尿的食物，如：鲫鱼、鲤鱼、冬瓜等。

                    4.2.4注意事项：准妈妈在37周前，需特别预防早产的发生，如果阵痛超过30分钟以上且持续增加，并伴有阴道出血或出水现象，一定立即送医院检查。
                </p>}

                {pregStatus === 8 && <p>
                    5、预产期前七天

                    5.1参考话术：

                    **女士，您现在已进入预产期倒计时阶段了，请问您是否有动产迹象？如果您有动产迹象或者入院待产了，请您一定要第一时间告知我，以便我为您安排入住前事宜。我们有为您准备了两件月子服与一双月子鞋，需要了解一下您目前穿的衣服与鞋子的码数。

                    如订单上已有饮食禁忌，看着订单跟客人再次确认饮食禁忌。如订单上无：请问您在饮食上有没有过敏或者不能吃的食物？如果有特殊的，我们会告知营养师以便为您更好的个性化制定餐食。

                    因为每个宝妈的泌乳情况不太一样，为避免宝宝前期吃不够奶水的情况，您可以准备一小罐奶粉备不时之需。您分娩后不能马上喝催奶汤，因产后72小时是生理性涨奶期，此阶段喝催奶汤不仅没有效果，还容易导致奶液浓稠，引起乳房胀痛，导致发烧。

                    剖腹产的宝妈需要通气后方可进食，建议在医院时可食用萝卜汤排气，通气后可根据医生建议进行清淡饮食。

                    5.2未分娩：宝宝可能还想在您子宫里多待一会儿呢，不要着急哦，实际上准时出生的宝宝只有5%，有几天的出入也是正常情况，您要尽量保持心情畅快，迎接宝宝的到来哦！如果您有动产迹象或者入院待产了，请您一定要第一时间告知我，方便我为您安排入住前事宜。

                    5.3已分娩：恭喜您，请问是男宝宝还是女宝宝呢？宝宝什么时候出生的呢？（分娩日期），恭喜宝妈晋级了，喜得小公主/小王子。

                    5.4关心客户情况：请问您现在身体情况怎样？您是顺产还是剖腹产呢？若是顺产，问询客户是否有撕裂或者侧切，提示做好伤口清洁；若是剖腹产，提醒客户多卧床休息，排气后可吃些流食。（了解分娩方式）

                    5.5了解宝妈乳房和奶水情况：

                    ①计划母乳喂养的宝妈：请问现在有奶水了吗？可以适当给宝宝吸吮，促进泌乳，每次5-10分钟/边，不要太长时间，以免引起乳头皲裂。若宝妈有涨奶或者乳头皲裂情况，可让产康通乳师联系客户给予指导。

                    ②不母乳的宝妈：请问您有涨奶的感觉吗？您在医院期间做好乳房日常清洁就可以了，入住后我会安排通乳师和营养师配合给您做回奶计划。

                    5.6根据客户套餐内容，如套餐内赠送医院陪护，及时协调护理师人员安排。

                    参考话术：宝妈，您套餐内有赠送医院陪产服务（顺3剖5，按照签单情况告知客户具体天数），您入院待产后告诉我，提前为您做好准备，生产后记得第一时间告诉我分娩医院床位号、家属联系方式和陪产到岗的时间，我会协调安排陪产人员及时过去。

                    5.7注意事项：分娩后在合适时间进行入住信息采集，为入住接待做准备。（分娩日期，分娩方式，宝宝性别，体重，出院时间，车接地址，出院小结等提醒）

                    备注：预产期前七天需每天跟进客户分娩动态，告知客户分娩后的服务内容，为接下来服务开展做铺垫，回访后做记录。
                </p>}

                {pregStatus === 9 && <p>
                    5.3已分娩：恭喜您，请问是男宝宝还是女宝宝呢？宝宝什么时候出生的呢？（分娩日期），恭喜宝妈晋级了，喜得小公主/小王子。

                    5.4关心客户情况：请问您现在身体情况怎样？您是顺产还是剖腹产呢？若是顺产，问询客户是否有撕裂或者侧切，提示做好伤口清洁；若是剖腹产，提醒客户多卧床休息，排气后可吃些流食。（了解分娩方式）

                    5.5了解宝妈乳房和奶水情况：

                    ①计划母乳喂养的宝妈：请问现在有奶水了吗？可以适当给宝宝吸吮，促进泌乳，每次5-10分钟/边，不要太长时间，以免引起乳头皲裂。若宝妈有涨奶或者乳头皲裂情况，可让产康通乳师联系客户给予指导。

                    ②不母乳的宝妈：请问您有涨奶的感觉吗？您在医院期间做好乳房日常清洁就可以了，入住后我会安排通乳师和营养师配合给您做回奶计划。

                    5.6根据客户套餐内容，如套餐内赠送医院陪护，及时协调护理师人员安排。

                    参考话术：宝妈，您套餐内有赠送医院陪产服务（顺3剖5，按照签单情况告知客户具体天数），您入院待产后告诉我，提前为您做好准备，生产后记得第一时间告诉我分娩医院床位号、家属联系方式和陪产到岗的时间，我会协调安排陪产人员及时过去。

                    5.7注意事项：分娩后在合适时间进行入住信息采集，为入住接待做准备。（分娩日期，分娩方式，宝宝性别，体重，出院时间，车接地址，出院小结等提醒）

                    备注：预产期前七天需每天跟进客户分娩动态，告知客户分娩后的服务内容，为接下来服务开展做铺垫，回访后做记录。
                </p>}

                {pregStatus === 10 && <p>
                    6、超过预产期

                    6.1参考话术：X女士，请问现在有分娩迹象了吗？（还没有）宝宝可能觉得在您子宫里面太舒适了，还不着急出来和您见面，您不要着急哦，有几天的出入也是正常情况，您要尽量保持心情畅快，超过预产期后去医院进行孕检看看宝宝的具体情况，根据医生的建议看是否需要催产。如果您有动产迹象或者入院待产了，请您一定要第一时间告知我，方便我为您安排入住前事宜。

                    分娩是一件极耗体力且辛苦的事情，您可以准备一些易消化的食物，以免在分娩期感到饥饿（如鸡蛋、红糖、饼干、葡萄干、巧克力等），不过分娩期间能否进食，要根据分娩医院具体情况而定。分娩前尽量选择能有效补充能量和能缓解疼痛的食物，主食可参考：面条、小米粥、奶、蛋和瘦肉，绿叶菜等。

                    6.2建议客人坚持数胎动，有任何不适，及时去医院，并将分娩信息及时告知管家。
                </p>}

            </div>
        </Modal>
    </Fragment>
}